export const idToSafeString = (prefix: string, id: number) => {
  const idString = id.toString().toLowerCase();
  const noSpecialString = prefix.replace(/[^a-zA-Z0-9 ]/g, '');
  const safeString = noSpecialString.replace(/\s+/g, '-').toLowerCase();

  return `${safeString}-${idString}`;
};
